gsap.registerPlugin(SplitText);

const splitWrapper = document.querySelectorAll(".roller-wrapper");
if (!splitWrapper) return;

splitWrapper.forEach((wrapper) => {
  const mainLine = wrapper.querySelector(".main-line");
  const altLine = wrapper.querySelector(".alt-line");

  const main = new SplitText(mainLine, { type: "words" });
  const alt = new SplitText(altLine, { type: "words" });

  gsap.set(alt.words, { y: 30, opacity: 0 });

  wrapper.addEventListener("mouseenter", () => {
    main.words.forEach((w, i) => {
      gsap.to(w, {
        y: -30,
        opacity: 0,
        duration: 0.4,
        ease: "power2.out",
        delay: i * 0.05,
      });
    });

    alt.words.forEach((w, i) => {
      gsap.to(w, {
        y: 0,
        opacity: 1,
        duration: 0.4,
        ease: "power2.out",
        delay: i * 0.05 + 0.05,
      });
    });
  });

  wrapper.addEventListener("mouseleave", () => {
    main.words.forEach((w, i) => {
      gsap.to(w, {
        y: 0,
        opacity: 1,
        duration: 0.4,
        ease: "power2.out",
        delay: i * 0.05 + 0.05,
      });
    });

    alt.words.forEach((w, i) => {
      gsap.to(w, {
        y: 30,
        opacity: 0,
        duration: 0.4,
        ease: "power2.out",
        delay: i * 0.05,
      });
    });
  });
});
